<template>
  <div ref="dividerRef" class="addon lf-divider" :style="dividerStyles">
    <span class="lf-divider__border" :style="model.state.elementStyling?.inline"></span>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { watch } from 'vue';
import { computed, defineComponent, nextTick, onMounted, ref } from 'vue';

import type { AddonLfDividerModel } from './Model';
import useDevice from '@/src/hooks/useDevice';
import { useCampaignStore } from '@/src/store/campaign';

export default defineComponent({
  name: 'AddonLfDivider',
  props: {
    model: {
      type: Object as PropType<AddonLfDividerModel>,
      required: true
    }
  },
  setup(props) {
    const campaignStore = useCampaignStore();
    const isReady = ref(false);
    const dividerRef = ref<HTMLElement>();

    /**
     * Grab the column width
     * We need the width from the column on mobile as the parent element has
     * width set to "auto", which causes the width to be 0 in some special cases
     * Eg: When the column has style="align-items:center"
     */
    const dividerWidth = computed(() => {
      if (dividerRef.value) {
        return dividerRef.value.parentElement?.parentElement?.clientWidth + 'px';
      }
      return '100%';
    });

    const dividerStyles = computed(() => {
      const { isMobile } = useDevice();
      return {
        ...props.model.state.elementStyling?.align,
        ...(isMobile && { width: dividerWidth.value })
      };
    });

    const showDivider = () => {
      isReady.value = true;
    };

    onMounted(() => {
      showDivider();
    });

    watch(
      () => campaignStore.currentDevice,
      async () => {
        isReady.value = false;
        await nextTick();
        showDivider();
      }
    );

    return {
      dividerStyles,
      dividerRef
    };
  }
});
</script>

<style lang="scss">
.lf-divider__border {
  display: inline-block;
}
</style>
